<div class="ub-card" joyrideStep="step.userbadge" stepPosition="right" [title]="getTourData('step.userbadge','title')"
  [text]="getTourData('step.userbadge','text')" [class.landing-side1]="landingsidesticky1" #landingside1>

  <ng-container *ngIf="!loadAPIcall">

    <!-- Banner — user's uploaded banner image when present, else the purple
         gradient + dot pattern fallback defined in SCSS. -->
    <div class="ub-banner"
         [class.has-image]="bannerUrl"
         [style.background-image]="bannerUrl ? 'url(' + bannerUrl + ')' : null"></div>

    <!-- Avatar overlapping banner -->
    <div class="ub-avatar-wrap">
      <!-- When user has a photo -->
      <div *ngIf="ProfileComplete?.photo && ProfileComplete?.photo !== 'null' && ProfileComplete?.photo !== ''"
           class="ub-avatar ub-avatar-photo">
        <circle-progress [percent]="ProfileComplete?.completePercentage" [radius]="100" [outerStrokeWidth]="8"
          [outerStrokeColor]="'#8B5CF6'" [innerStrokeColor]="'#ffffff'" [animation]="true" [animationDuration]="300"
          [showImage]="true" [showBackground]="true" [imageSrc]="ProfileComplete?.photo" [responsive]="true"
          [space]="3" data-toggle="tooltip" data-placement="top" title="{{ ProfileComplete?.completePercentage }}"
          (click)="route(ProfileComplete?.userId)" class="user-profile">
        </circle-progress>
      </div>
      <!-- When user has no photo - initials -->
      <div *ngIf="!ProfileComplete?.photo || ProfileComplete?.photo === 'null' || ProfileComplete?.photo === ''"
           class="ub-avatar ub-avatar-initials">
        <div class="circle-initials-wrapper">
          <circle-progress [percent]="ProfileComplete?.completePercentage" [radius]="100" [outerStrokeWidth]="8"
            [outerStrokeColor]="getTextColor(ProfileComplete?.firstName, ProfileComplete?.lastName)"
            [innerStrokeWidth]="0" [showImage]="false" [showBackground]="false" [showTitle]="false"
            [showSubtitle]="false" [showUnits]="false" [responsive]="true" [space]="3">
          </circle-progress>
          <div class="initials-overlay"
            [style.background-color]="getColorParam(ProfileComplete?.firstName, ProfileComplete?.lastName)"
            (click)="route(ProfileComplete?.userId)">
            <span class="initials-text" [style.color]="getTextColor(ProfileComplete?.firstName, ProfileComplete?.lastName)">
              {{ getInitials(ProfileComplete?.firstName, ProfileComplete?.lastName) }}
            </span>
          </div>
        </div>
        <div class="progress-percentage-below">
          {{ ProfileComplete?.completePercentage }}% Complete
        </div>
      </div>
    </div>

    <!-- Body -->
    <div class="ub-body">

      <div class="ub-name text-ellipses-1 curpoint" (click)="route(ProfileComplete?.userId)"
           data-toggle="tooltip" data-placement="top"
           title="{{ ProfileComplete?.firstName }} {{ ProfileComplete?.lastName }}">
        {{ ProfileComplete?.firstName }} {{ ProfileComplete?.lastName }}
      </div>

      <div class="ub-title text-ellipses-1" data-toggle="tooltip" data-placement="top"
           title="{{ ProfileComplete?.title }} @{{ organizationname }}">
        {{ title }} <span *ngIf="organizationname">&#64;</span> {{ organizationname }}
      </div>

      <div class="ub-title text-ellipses-1" data-toggle="tooltip" data-placement="top"
           title="{{ ProfileComplete?.city }}{{ ProfileComplete?.state }}" style="margin-bottom: 4px;">
        {{ ProfileComplete?.city }}<span *ngIf="ProfileComplete?.city">{{ ", " }}</span>{{ ProfileComplete?.state }}
      </div>

      <!-- JOB_SEEKER profile completion prompt -->
      <div [ngbCollapse]="collapseProfileCompletion">
        <div class="ub-jobseeker-cta" *ngIf="userType == 'JOB_SEEKER'">
          <button class="btn btn-primary btn-xs" *ngIf="show" (click)="route(ProfileComplete.userId)">
            Complete Your Profile
          </button>
        </div>
      </div>

      <!-- Stats — JOB_SEEKER variant -->
      <div id="twoo" *ngIf="userType === 'JOB_SEEKER'" class="ub-stats">
        <div [routerLink]="['/landingPage/connection']" class="ub-stat">
          <div class="ub-stat-val">{{ ProfileComplete?.connectionCnt }}</div>
          <div class="ub-stat-lbl">Contacts</div>
        </div>
        <div *ngIf="userType == 'JOB_SEEKER'" class="ub-stat">
          <div class="ub-stat-val">{{ ProfileComplete?.postCnt }}</div>
          <div class="ub-stat-lbl">Post</div>
        </div>
        <div (click)="selectMenu('newcandidates')" [routerLink]="['/newcandidates']"
             *ngIf="userType == 'JOB_SEEKER' || userType == 'student'" class="ub-stat">
          <div class="ub-stat-val">{{ ProfileComplete?.candidatesCount }}</div>
          <div class="ub-stat-lbl">Candidates</div>
        </div>
      </div>

      <!-- Stats — non JOB_SEEKER variant -->
      <div class="ub-stats" *ngIf="userType != 'JOB_SEEKER'">
        <div *ngIf="userType != 'JOB_SEEKER'" [routerLink]="['/planUsageTracking', 'Contacts']" class="ub-stat">
          <div class="ub-stat-val">{{ planCount?.includedContactsCount }}</div>
          <div class="ub-stat-lbl">Contacts</div>
        </div>

        <div *ngIf="userType === 'RECRUITER' || userType === 'BENCH_RECRUITER'"
             [routerLink]="['/planUsageTracking', userType === 'RECRUITER' ? 'Jobs' : 'Candidates']" class="ub-stat">
          <div class="ub-stat-val">{{ (userType === 'RECRUITER') ? activejobcount : activeCandidatesCount }}</div>
          <div class="ub-stat-lbl">{{ userType === 'RECRUITER' ? 'Jobs' : 'Candidates' }}</div>
        </div>

        <div [routerLink]="['/planUsageTracking', 'Jobs & Candidates']"
             *ngIf="userType === 'FREELANCE_RECRUITER' || userType === 'MANAGEMENT_TALENT_ACQUISITION'" class="ub-stat">
          <div *ngIf="gigsumoService?.jobCandidateCountUpdatedTo == null; else countChangedTo" class="ub-stat-val">
            {{ totalCount }}
          </div>
          <div class="ub-stat-lbl">Jobs &amp; Cands</div>
        </div>

        <div [routerLink]="['/planUsageTracking', 'Active Interactions']" routerLinkActive="router-link-active"
             class="ub-stat">
          <div class="ub-stat-val">{{ planCount?.interactionCount }}</div>
          <div class="ub-stat-lbl">Interactions</div>
        </div>
      </div>

      <!-- Plan row + Upgrade -->
      <div class="ub-plan-row" *ngIf="userType !== 'JOB_SEEKER' && (gigsumoService?.planUpdatedTo || PlanName)">
        <div class="ub-plan-info">
          <div class="ub-plan-label">Current plan</div>
          <div class="ub-plan-name">{{ gigsumoService?.planUpdatedTo || PlanName }} Plan</div>
        </div>
        <button class="ub-upgrade-btn" *ngIf="userType != 'JOB_SEEKER' && PlanName != highestPlan"
                (click)="upgrade()" [routerLink]="['/plan-quota']">
          <ng-icon name="tablerTrendingUp" class="gs-ico-sm"></ng-icon> Upgrade
        </button>
      </div>

      <!-- Profile Completeness -->
      <div class="ub-completeness">
        <div class="ub-comp-hdr">
          <span class="ub-comp-label">Profile Completeness</span>
          <span class="ub-comp-pct">{{ ProfileComplete?.completePercentage }}%</span>
        </div>
        <div class="ub-comp-track">
          <div class="ub-comp-fill" [style.width]="(ProfileComplete?.completePercentage || 0) + '%'"></div>
        </div>
        <div class="ub-comp-action" (click)="route(ProfileComplete?.userId)">
          <ng-icon name="tablerCirclePlus" class="gs-ico-sm"></ng-icon>
          <span>Add a Skill +10%</span>
        </div>
      </div>

      <!-- Recent Endorsements -->
      <div class="ub-endorsements">
        <div class="ub-end-label">Recent Endorsements</div>
        <div class="ub-end-stars">
          <div class="ub-end-star">⭐</div>
          <div class="ub-end-star">⭐</div>
          <div class="ub-end-star">⭐</div>
        </div>
      </div>

      <!-- Member Since -->
      <div class="ub-member-since">
        Member since {{ ProfileComplete?.createdOn | date:'MMMM d, y' }}
      </div>

    </div>
  </ng-container>

  <app-common-skeleton *ngIf="loadAPIcall" [NameOftheScreen]="'userBadge'"></app-common-skeleton>

</div>

<ng-template #countChangedTo>
  <div class="ub-stat-val">
    {{ gigsumoService.jobCandidateCountUpdatedTo }}
  </div>
</ng-template>
